export default "__VITE_ASSET__Bjnpcnp1__"